// advancedAttachments
// wrapper for blueimp uploader

bq.advancedAttachments = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.fileInput = null;
  this._dragging = undefined;
  this._progressInterval = undefined;
  this._currentUploadObject = false;
  this._removedFiles = [];
  this._tmpParams = false;
  this._events = {
    'ajaxStart': 'bq.attachments.ajaxStart',
    'ajaxEnd': 'bq.attachments.ajaxEnd',
    'uploadStart': 'bq.attachments.uploadStart',
    'uploadEnd': 'bq.attachments.uploadEnd'
  };

};

bq.advancedAttachments.DEFAULTS = {
  uploadUrl: '', //required for AJAX
  removeUrl: '',
  updateUrl: '',
  progressUrl: '',
  reloadUrl: '',
  ajaxParams: {},
  sequential: true,
  replaceFileInput: true,
  dropZone: false,
  progressBar: false, //not implimented
  progressList: false,
  input: '.attachment-file-upload',
  fileList: '.attachment-list',
  relatedInputs: true,
  relatedContainer: document,
  fullscreenDrop: false,
  dropZoneOverlay: '.fullpage-dropzone',
  templates: {}
  
};

bq.advancedAttachments.prototype = {

  init: function(opt) {
    bq.debug.log("Advanced Attachments : init()", this.$element);

    if(this.options.uploadUrl.length <= 0) { //if no url or type exit
      bq.debug.error("Advanced Attachments : required data-* missing", this);
      return;
    }

    this.fileInput = $(this.options.input, this.$element);

    if(this.options.fullscreenDrop) {
        $(window).on('dragenter dragstart', {this:this}, this._catchDragEnterEvent);
        $(window).on('dragleave drop', {this:this}, this._catchDragLeaveEvent);
        $(window).on('dragover', {this:this}, this._catchDragOverEvent);
    }

    $(window).on('advanced.upload.block.reload', {this:this}, this._catchReloadEvent);
    this.$element.on('fileuploadadd', {this:this}, this._catchFileAddEvent);
    this.$element.on('fileuploadsend', {this:this}, this._catchFileSendEvent);
    this.fileInput.bind('fileuploadalways', {this:this}, this._catchUploadComplete);

    this.$element.on('click', '[data-action-remove], [data-action-cancel]', {this:this}, this._catchDeleteFile);
    this.$element.on('change', '[data-line-number], [data-send-type]', {this:this}, this._catchChangeEvent);

    if(this.options.relatedInputs && this.options.relatedContainer) {
        $(this.options.relatedContainer).on('change', '[data-advanced-attach]', {this:this}, this._catchRelatedFileInput);
    }

    this._createFileUpload();
  },

  _createFileUpload: function() {
    var o = {};

    o.url = this.options.uploadUrl;
    o.replaceFileInput = this.options.replaceFileInput;
    o.sequentialUploads = this.options.sequential;
    o.formData = this.options.ajaxParams;
    o.dataType = 'json';

    if(this.options.dropZone) {
        tmpOptions.dropZone = $(this.options.dropZoneSelector, this.$element);
    } else if(!this.options.fullscreenDrop) {
        tmpOptions.dropZone = null; // Set to null or an empty jQuery collection to disable drag & drop support
    }

    var uploadObj = this.fileInput.fileupload(o);
    var dropZoneElement = uploadObj.fileupload('option', 'dropZone');
    var uuid = uploadObj.data('blueimp-fileupload').uuid;
    var widgetName = uploadObj.data('blueimp-fileupload').widgetName;
    var events = $._data(dropZoneElement[0], 'events');

    // Remove event handlers for the same drop zone, added by previous initialization
    ['dragenter', 'dragleave', 'dragover', 'drop'].forEach(function (eventName) {
        if (events[eventName] !== undefined && events[eventName].length > 1) {
            events[eventName].forEach(function (event) {
                if (event.namespace.indexOf(widgetName) === 0 && event.namespace !== (widgetName + uuid)) {
                    dropZoneElement.unbind(eventName + '.' + event.namespace)
                        .undelegate(eventName + '.' + event.namespace);
                }
            });
        }
    });
  },

  _toggleFullScreenDrop: function(hide) {
    var el = $(this.options.dropZoneOverlay, this.$element);
    if(hide) {
        el.hide();
    } else {
        el.show();
    }
  },

  _processError: function(response, uploadObject) {
    var $this = this,
        parent = this._getprogressList(),
        template = $(this.options.templates.error),
        mainId = uploadObject.context;

    if(template.length != 1 || !uploadObject.files || !parent) { return; }

    $.each(uploadObject.files, function(i, file){

        var error = template.clone().attr('id', file.context);

        var fileData = file;
        fileData.displaysize = bq.helper.fileSize(fileData.size);
        fileData.message = response.error;

        bq.helper.fillData(error, fileData);

        if(parent.find('#'+file.context).length >= 1) {
            parent.find('#'+file.context).replaceWith(error);
        } else {
            parent.prepend(error);
        }
    });
  },

  _processResults: function(response, uploadObject) {
    if(!response) { return; }

    if(response.html) {
        this.$element.find(this.options.fileList).html(response.html);
        if (this.$element.find('.attachment-list-item-edit').length === 0) {
            this.$element.removeClass('attachments-uploading');
        }
    }

    if(response.error) {
        this._processError(response, uploadObject);
    } else if(uploadObject) {
        var $this = this;
        $.each(uploadObject.files, function(i, file){
            $this._clearProgress(file.context);
        });
    }
  },

  _call: function(url, id, type, param, target) {
    
    if(!param) { params = {}; }

    var params = $.extend({}, this.options.ajaxParams, param, {file_id: id, ajax: true}),
        $this = this,
        eventTarget = target ? target : this.$element,
        eventData = {
            'this': $this,
            'param': params,
            'url': url
        };

    bq.helper.throwEvent($this._events.ajaxStart, eventTarget, eventData);

    $this.$element.append('<div class="attachments-lock"></div>');
    $.getJSON(url, params)
      .always(function(data, textStatus, jqXHR) {
        eventData.results = data;
        bq.helper.throwEvent($this._events.ajaxEnd, eventTarget, eventData);
        $this._processResults(data);
        $this.$element.find('.attachments-lock').remove();
      });
  },

  _remove: function(row) {
      var id = row.data('id');
      var rowParams = row.data('ajaxParams') ? row.data('ajaxParams') : {};
      var params = { ...rowParams, line_entity_id: rowParams.entity_id };
      delete params.entity_id;
    if(!id) {
        row.fadeOut(400, function() { $(this).remove(); });
    } else {
        this._call(this.options.removeUrl, id, 'remove', params, row);
    }
  },

  _update: function(row) {
    var id = row.data('id'),
        params = bq.helper.formToObject(row);

    this._call(this.options.updateUrl, id, 'update', params, row);
  },

  _reload: function(params, target) {
      this._call(this.options.reloadUrl, 0, 'reload', params, target)
  },

  _getprogressList: function() {
    var parent = this.options.progressList ? this.options.progressList : this.options.fileList;
    
    return this.$element.find(parent);
  },

  _clearProgress: function(id) {
    if(id) {
        var parent = this._getprogressList();
        parent.find('#'+id).remove();
    }
  },

  _generateProgress: function(data) {

    var $this = this,
        parent = this._getprogressList(),
        template = $(this.options.templates.progress),
        mainId = data.context;

    if(template.length != 1 || !data.files || !parent) { return; }

    $this.$element.addClass('attachments-uploading');

    $.each(data.files, function(i, file){

        var progress = template.clone().attr('id', mainId+'_'+i);
        file.context = mainId+'_'+i;

        var fileData = file;
        fileData.displaysize = bq.helper.fileSize(fileData.size);

        bq.helper.fillData(progress, fileData);
        progress.data('file', fileData);

        parent.prepend(progress);
    });

    if(parent.find('[data-progress-hide]')) {
       parent.find('[data-progress-hide]').hide(); 
    }
  },

  _catchUploadComplete: function(e, data) {
    var $this = e.data.this;

    if(data.errorThrown === "abort") {
      data.result = {
        name: data.files[0].name,
        size: 0,
        error: $this.options.canceledMessage
      };
    }

    $this._processResults(data.result, data);
    $this._currentUploadObject = false;
  },

  _catchFileAddEvent: function(e, data) {
    var $this = e.data.this,
        id = ++bq.helper.uniqueIdCounter;
    data.context = 'auto_attachment_'+id;
    $this._generateProgress(data);
  },

  _catchFileSendEvent: function(e, data) {
    var $this = e.data.this,
        context = data.context,
        file = data.files[0].context;

    if ($.inArray(data.files[0].name, $this._removedFiles) == -1) {
        $this._currentUploadObject = data;

        $this.$element.find('#'+file).find('[data-progress-bar]').width('100%');
        $this.$element.find('#'+file).data('xhr', data);
    } else {
        var i = $.inArray(data.files[0].name, $this._removedFiles);
        $this._removedFiles.splice(i, 1);
        return false;
    }
  },

  _catchDragEnterEvent: function(e) {
    var $this = e.data.this;
    var effectAllowed = e.originalEvent.dataTransfer.effectAllowed;

    if (effectAllowed === 'uninitialized' || effectAllowed === 'none') {
      e.preventDefault();
      return;
    }

    $this._toggleFullScreenDrop();
  },

  _catchDragOverEvent: function(e) {
    var $this = e.data.this;
    
    if ($this._dragging) {
        clearTimeout($this._dragging);
        $this._dragging = undefined;
    }
  },

  _catchDeleteFile: function(e) {
    var $this = e.data.this,
        row = $(this).closest('[data-id]'),
        progress = row.data('progress'),
        $data = row.data('xhr');

    if(progress && $data) {
        try {
            $data.abort();
            $data.xhr().abort();
        } catch(er){}
        
        $data.result = {
            name: $data.files[0].name,
            size: 0,
            error: $this.options.canceledMessage
        };

        $this._processResults($data.result, $data);
    } else if(progress && !$data) {
        var file = row.data('file');

        var result = {
            name: file.name,
            size: 0,
            error: $this.options.canceledMessage
        };

        var tmpData = {
            context: '',
            files: [file]
        };

        $this._processResults(result, tmpData);
        $this._removedFiles.push(file.name);
    } else {
        $this._remove(row);
    }
  },

  _catchChangeEvent: function(e) {
    var $this = e.data.this,
        row = $(this).closest('[data-id]');

    $this._update(row);
  },

  _catchReloadEvent: function(e) {
    var $this = e.data.this,
        target = $(this),
        params = $this.options.ajaxParams;

    $this._reload(params, target);
  },

  _catchUploadSubmit: function(e) {
    var $this = e.data.this;
  },

  _catchRelatedFileInput: function(e) {
    var $this = e.data.this,
        target = $(this),
        params = $this.options.ajaxParams;

    if(target.data('ajaxParams')) {
        params = $.extend(params, target.data('ajaxParams'));
    }

    $this.fileInput.fileupload('add', {
        files: e.target.files || [{name: this.value}],
        fileInput: $(this),
        formData: params
    });

  },

  _catchDragLeaveEvent: function(e) {
    var $this = e.data.this;
    //e.data.this._toggleFullScreenDrop(true);

    $this._dragging = setTimeout(function() {
        $this._dragging = undefined;
        $this._toggleFullScreenDrop(true);
    }, 100);
  }

};


// advancedAttachments PLUGIN DEFINITION
// =======================

var advancedAttachmentsold = $.fn.advancedAttachments;

$.fn.advancedAttachments = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.advancedAttachments');
    var options = $.extend({}, bq.advancedAttachments.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.advancedAttachments', (data = new bq.advancedAttachments(this, options))); }
    data.init();
  });
};

$.fn.advancedAttachments.Constructor = bq.advancedAttachments;

// advancedAttachments NO CONFLICT
// =================

$.fn.advancedAttachments.noConflict = function () {
  $.fn.advancedAttachments = advancedAttachmentsold;
  return this;
};

// advancedAttachments DATA-API
// ==============

bq.advancedAttachmentsInit = function() {
  $('[data-bq="advanced-attachments"]').each(function () {
    var el = $(this);
    if(el.data('bq.advancedAttachments')) { return; }
    el.advancedAttachments(el.data());
  });
};

bq.init.push(bq.advancedAttachmentsInit);
